export default __webpack_public_path__ + "img/ed27613f8d0c803bf032f3bf5f5c668e.png";